<template>
  <div class="chat-widget__message-batch">
    <ProgressBar :value="message.progress"></ProgressBar>
    <div class="chat-widget__message-batch-assistants">
      <div v-for="assistant in message.assistants" :key="assistant.id" class="chat-widget__message-batch-assistant">
        <Avatar :image="assistant.icon" shape="circle" v-tooltip.bottom="assistant.name" />
        &nbsp;-&nbsp;
        <div v-tooltip.bottom="assistant.status">
          <i v-if="assistant.status === ASSISTANT_PROGRESS_STATUS.WORKING" class="pi pi-spin pi-spinner"></i>
          <i v-else :class="['pi', map[assistant.status]]"></i>
          <span v-if="assistant.id !== lastAssistantId">,</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import ProgressBar from "primevue/progressbar";
import Avatar from "primevue/avatar";
import {ASSISTANT_PROGRESS_STATUS} from "@/constants";
import {computed} from "vue";

const map = {
  [ASSISTANT_PROGRESS_STATUS.WORKING]: 'pi-spin pi-spinner',
  [ASSISTANT_PROGRESS_STATUS.WAITING]: 'pi-circle',
  [ASSISTANT_PROGRESS_STATUS.ERROR]: 'pi-times',
  [ASSISTANT_PROGRESS_STATUS.CANCELED]: 'pi-ban',
  [ASSISTANT_PROGRESS_STATUS.DONE]: 'pi-check-circle',
};

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
});

const lastAssistantId = computed(() => props.message.assistants[props.message.assistants.length - 1].id);

</script>